import { ClientHelper } from '../client/CreateNswagClient';

export class ProfileFilesService {
  static async listProfileFiles(token: string) {
    const filesClient = ClientHelper.createFilesClient(token);
    const items = await filesClient.list('profiles', null);
    const files = (items ?? []).filter((item: any) => !item.isFolder);
    return files.map((item: any) => {
      const rawName = item.fileName ?? item.blobPath ?? '';
      const clean = rawName.replace(/\\/g, '/');
      const baseName = clean.includes('/') ? clean.split('/').pop() ?? rawName : rawName;
      return { ...item, fileName: baseName || item.fileName };
    });
  }
}
